/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

import {
     DatabaseAudioPageBlockFromJSONTyped,
     DatabasePageBlockFromJSONTyped,
     DatabaseNamePageBlockFromJSONTyped,
     DatabaseTeaserImagePageBlockFromJSONTyped,
     DatabaseTitlePageBlockFromJSONTyped,
     DatabaseFieldPageBlockFromJSONTyped,
     DatabaseImagePageBlockFromJSONTyped,
     DatabaseImageListPageBlockFromJSONTyped,
     DatabaseMapPageBlockFromJSONTyped,
     DatabaseTextPageBlockFromJSONTyped,
     DatabaseVideoPageBlockFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface DatabasePageBlock
 */
export interface DatabasePageBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    blockType?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    slot?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    inlineStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePageBlock
     */
    link?: string;
    /**
     * Field ID that might override the content
     * @type {string}
     * @memberof DatabasePageBlock
     */
    overrideBy?: string;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabasePageBlock
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
}

/**
 * Check if a given object implements the DatabasePageBlock interface.
 */
export function instanceOfDatabasePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePageBlockFromJSON(json: any): DatabasePageBlock {
    return DatabasePageBlockFromJSONTyped(json, false);
}

export function DatabasePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['blockType'] === 'AUDIO') {
            return DatabaseAudioPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'BASE') {
            return DatabasePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_NAME') {
            return DatabaseNamePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_TEASER_IMAGE') {
            return DatabaseTeaserImagePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'DB_TITLE') {
            return DatabaseTitlePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'FIELD') {
            return DatabaseFieldPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'IMAGE') {
            return DatabaseImagePageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'IMAGE_LIST') {
            return DatabaseImageListPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'MAP') {
            return DatabaseMapPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'TEXT') {
            return DatabaseTextPageBlockFromJSONTyped(json, true);
        }
        if (json['blockType'] === 'VIDEO') {
            return DatabaseVideoPageBlockFromJSONTyped(json, true);
        }
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'blockType': !exists(json, 'blockType') ? undefined : json['blockType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'slot': !exists(json, 'slot') ? undefined : json['slot'],
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'link': !exists(json, 'link') ? undefined : json['link'],
        'overrideBy': !exists(json, 'overrideBy') ? undefined : json['overrideBy'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
    };
}

export function DatabasePageBlockToJSON(value?: DatabasePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'blockType': value.blockType,
        'id': value.id,
        'slot': value.slot,
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'link': value.link,
        'overrideBy': value.overrideBy,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
    };
}

